import React from 'react'
import './Palette.css'
import { useTranslation } from 'react-i18next'

const Palette = (props) => {
    const { t } = useTranslation()
    return (
        <div className={props.className}>
            <span>{props.value}</span>
            <label>{t(props.name.trim())}</label>
        </div>
    )
}

export default Palette
